import analytics from '../analytics'
import { Roles } from '@survey/context/RoleProvider'
import {
  FileType,
  AppState,
  LogoutMode,
  PageEntryMode,
  ProfileActionType,
  ViewMode,
  ActionMode,
  SearchState,
} from '@hooks/analytics/typings'

const useAnalytics = () => {
  const { trackCustomEvent } = analytics

  const trackLogin = (role: Roles, state: AppState) => {
    trackCustomEvent({ role, event: 'login', state })
  }

  const trackPageEntry = (role: Roles, mode: PageEntryMode) => {
    trackCustomEvent({ role, event: 'landing', mode })
  }

  const trackDownload = (role: Roles, url: string, type: FileType) => {
    trackCustomEvent({ event: 'click', url, eventType: type, role })
  }

  const trackLogout = (role: Roles, mode: LogoutMode) => {
    trackCustomEvent({ role, event: 'logout', mode })
  }

  const trackContact = (title: string) => {
    trackCustomEvent({
      role: 'general',
      event: 'click',
      eventType: 'contact',
      query: title,
    })
  }

  const trackSearch = (
    panelSatus: string[],
    compatibility: string[],
    zip: string,
    specialty: string[],
    organization: string[],
    compatibilityCount: number,
    distanceCount: number,
    state: AppState
  ) => {
    const query = `panelStatus=${panelSatus.join(
      ','
    )}&compatibilityScore=${compatibility.join(
      ','
    )}&zipCode=${zip}&specialties=${specialty.join(
      ','
    )}&organization=${organization.join(',')}`
    trackCustomEvent({
      role: 'patients',
      event: 'search',
      classification: 'compatibility',
      query,
      state: state,
      count: compatibilityCount,
    })
    trackCustomEvent({
      role: 'patients',
      event: 'search',
      classification: 'distance',
      query,
      state: state,
      count: distanceCount,
    })
  }

  const trackProviderProfileView = (
    id: string,
    mode: ViewMode,
    classification?: SearchState
  ) => {
    trackCustomEvent({
      role: 'patients',
      event: 'view',
      eventType: 'profile',
      mode: mode,
      query: id,
      classification,
    })
  }

  const trackPatientAction = (mode: ProfileActionType, state: AppState) => {
    trackCustomEvent({
      role: 'patients',
      event: 'action',
      eventType: 'profile',
      mode: mode,
      state,
    })
  }

  const trackSearchFilterAction = (mode: ActionMode) => {
    trackCustomEvent({
      role: 'patients',
      event: 'action',
      eventType: 'filter',
      mode: mode,
    })
  }

  const trackLoadMore = (classification: SearchState) => {
    trackCustomEvent({
      role: 'patients',
      event: 'click',
      mode: 'load-more',
      classification,
    })
  }

  return {
    trackLogin,
    trackPageEntry,
    trackDownload,
    trackLogout,
    trackContact,
    trackSearch,
    trackProviderProfileView,
    trackPatientAction,
    trackSearchFilterAction,
    trackLoadMore,
  }
}

export default useAnalytics
